import {
  CustomSectionAttributes,
  PageTemplateSectionSource,
} from 'api/custom-section/types';
import { HttpClient } from 'api/http-client';
import { MeetingTemplateSection } from 'api/pages';
import {
  GetSectionsAvailableForAddParams,
  GetUpdatedSectionsForNewSourcesParams,
  GetUpdatedSectionsForNewSourcesPayload,
  SearchSectionsParams,
} from './types';

class TemplateBuilderAPIClient extends HttpClient {
  public getSectionsForTemplates = (
    templateIds: number[],
  ): Promise<CustomSectionAttributes[]> =>
    this.get<CustomSectionAttributes[]>(
      'pages/template/builder/sections/group-source-sections',
      {
        params: {
          pageTemplateIds: templateIds.join(','),
        },
      },
    );
  public getUpdatedSectionsForNewSources = (
    params: GetUpdatedSectionsForNewSourcesParams,
  ): Promise<CustomSectionAttributes[]> =>
    this.post<
      GetUpdatedSectionsForNewSourcesPayload,
      unknown,
      CustomSectionAttributes[]
    >('pages/template/builder/sections/regroup-source-sections', {
      sourceTemplateSectionsState: params.sections,
      targetPageTemplateIds: params.newSourceIds,
      sourcePageTemplateIds: params.oldSourceIds,
    });
  public searchSections = (
    params: Partial<SearchSectionsParams>,
  ): Promise<PageTemplateSectionSource[]> =>
    this.get<PageTemplateSectionSource[]>(
      'pages/template/builder/sections/search',
      {
        params: {
          ...params,
          pageTemplateIds: params.pageTemplateIds?.join(','),
        },
      },
    );
  public getSectionsAvailableForAdd = (
    params: GetSectionsAvailableForAddParams,
  ): Promise<MeetingTemplateSection[]> =>
    this.post<
      GetSectionsAvailableForAddParams,
      unknown,
      MeetingTemplateSection[]
    >(
      'pages/template/builder/sections/group-source-sections-from-state',
      params,
    );
}

export const PageTemplateBuilderAPI = new TemplateBuilderAPIClient();
